module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "typeahead"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userText),
      expression: "userText"
    }],
    staticClass: "typeahead__input",
    domProps: {
      "value": (_vm.userText)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.userText = $event.target.value
      }, _vm.userInputHandler]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "typeahead__items-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showList && _vm.hasItems),
      expression: "showList && hasItems"
    }],
    staticClass: "typeahead__items"
  }, _vm._l((_vm.filteredItems), function(item) {
    return _c('div', {
      staticClass: "typeahead__item",
      on: {
        "click": function($event) {
          _vm.selectHandler(item)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item[_vm.property]) + "\n            ")])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb11219c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/typeahead/typeahead.vue
// module id = 156
// module chunks = 0